import { app } from '../../../app';
import { Controller } from './saml-idp-login.controller';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.login-saml-with-req-link', {
        url: '/loginSAML/:req/:link',
        templateUrl: require('../saml-login/saml-login.html'),
        controller: Controller,
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/public/saml-idp-login/saml-idp-login.state.js